module.exports = __webpack_public_path__ + "media/social/link-fb-95653257.png";